
import { IonApp, IonContent, IonIcon, IonAvatar, IonMenu, IonMenuToggle, IonSplitPane, toastController, isPlatform, menuController } from '@ionic/vue';
import { defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';
import { home, homeOutline, personAdd, personAddOutline, person, personOutline, walk, walkOutline, image, imageOutline, rocket, rocketOutline, cog, cogOutline, locate, locateOutline, navigate, navigateOutline, logOut, logOutOutline, documentOutline, document, boat, boatOutline} from 'ionicons/icons';
import {ActionPerformed,PushNotificationSchema,PushNotifications,Token} from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import PanelMenu from 'primevue/panelmenu';
import 'primeicons/primeicons.css';
import HelpSheet from './views/help/HelpSheet.vue';
import { docForRoute, isUpdatedSinceSeen, refreshDocsIndex } from './docsHelp';
import { PUSH_CHANNEL, PUSH_EVENT, pushRoute, rememberPushRoute } from './pushNotifications';

export default defineComponent({
  name: 'App',
  components: {
    IonApp, 
    IonContent, 
    IonIcon, 
    IonMenu, 
    IonMenuToggle, 
    IonAvatar,
    // IonRouterOutlet, 
    IonSplitPane,
    PanelMenu,
    HelpSheet
  },
  data(){
    return {
      name:'',
      email:'',
      avatarImg:null,
      // Screen help (see docsHelp.ts): guide for the current route, if one is published.
      helpOpen: false,
      helpSlug: null as string | null,
      helpAnchor: null as string | null,
      helpUpdated: false,
      items:[
          {
            key: "0",
            label: 'Home',
            icon: "pi pi-home",
            command:async ()=>{
              this.menuClose("/home");
            }
          },
          {
            key: "1",
            label: 'HR Management',
            icon: "pi pi-id-card",
            items: [
              {
                key: "1_0",
                label: 'Attendance',
                icon: "pi pi-clock",
                command:async ()=>{
                  this.menuClose("/hr/attendance");
                }
              },
              {
                key: "1_1",
                label: 'Apply for Leave',
                icon: "pi pi-calendar-plus",
                command:async ()=>{
                  this.menuClose("/hr/leave-apply");
                }
              },
              {
                key: "1_2",
                label: 'My Leaves',
                icon: "pi pi-calendar",
                command:async ()=>{
                  this.menuClose("/hr/my-leaves");
                }
              },
              {
                key: "1_3",
                label: 'Leave Approvals',
                icon: "pi pi-check-square",
                command:async ()=>{
                  this.menuClose("/hr/leave-approvals");
                }
              },
              {
                key: "1_4",
                label: 'Verify Field Visits',
                icon: "pi pi-map-marker",
                command:async ()=>{
                  this.menuClose("/hr/field-visits-verify");
                }
              },
              {
                key: "1_5",
                label: 'Manual Attendance',
                icon: "pi pi-pencil",
                command:async ()=>{
                  this.menuClose("/hr/manual-attendance-apply");
                }
              },
              {
                key: "1_6",
                label: 'Attendance Approvals',
                icon: "pi pi-check-circle",
                command:async ()=>{
                  this.menuClose("/hr/manual-attendance-approvals");
                }
              },
              {
                key: "1_7",
                label: 'Attendance Report',
                icon: "pi pi-file-pdf",
                command:async ()=>{
                  this.menuClose("/hr/attendance-report");
                }
              }
            ]
          },
          {
            key: "2",
            label: 'Sales',
            icon: "pi pi-chart-line",
            items: [
              {
                key: "2_10",
                label: 'Sales Leads',
                icon: "pi pi-bolt",
                command:async ()=>{
                  this.menuClose("/sales-leads");
                }
              },
              {
                key: "2_11",
                label: 'Lead Meetings',
                icon: "pi pi-calendar",
                command:async ()=>{
                  this.menuClose("/sales-lead-meetings");
                }
              },
              {
                key: "2_12",
                label: 'Lead Transfers',
                icon: "pi pi-share-alt",
                command:async ()=>{
                  this.menuClose("/sales-lead-transfers");
                }
              },
              {
                key: "2_0",
                label: 'Create Sale',
                icon: "pi pi-plus",
                command:async ()=>{
                  this.menuClose("/create-sale");
                }
              },
              {
                key: "2_1",
                label: 'My Sales',
                icon: "pi pi-user",
                command:async ()=>{
                  this.menuClose("/my-sales");
                }
              },
              {
                key: "2_2",
                label: 'All Sales',
                icon: "pi pi-folder-open",
                command:async ()=>{
                  this.menuClose("/all-sales");
                }
              },
            ]
          },
          {
            key: "3",
            label: 'Accounts',
            icon: "pi pi-wallet",
            items: [
              {
                key: "3_0",
                label: 'Request IOU',
                icon: "pi pi-send",
                command:async ()=>{
                  this.menuClose("/request-iou");
                }
              },
              {
                key: "3_1",
                label: 'My Sent IOU Requests',
                icon: "pi pi-arrow-up-right",
                command:async ()=>{
                  this.menuClose("/my-sent-iou-requests");
                }
              },
              {
                key: "3_2",
                label: 'My Received IOU Requests',
                icon: "pi pi-arrow-down-left",
                command:async ()=>{
                  this.menuClose("/my-received-iou-requests");
                }
              },
              {
                key: "3_3",
                label: 'Bill Submit',
                icon: "pi pi-file-export",
                command:async ()=>{
                  this.menuClose("/bill-submit");
                }
              },
              {
                key: "3_4",
                label: 'My Bills',
                icon: "pi pi-receipt",
                command:async ()=>{
                  this.menuClose("/my-bills");
                }
              },
              {
                key: "3_5",
                label: 'Received Bill Requests',
                icon: "pi pi-inbox",
                command:async ()=>{
                  this.menuClose("/received-bill-requests");
                }
              },
              {
                key: "3_6",
                label: 'Request IOU Back',
                icon: "pi pi-undo",
                command:async ()=>{
                  this.menuClose("/request-iou-back");
                }
              },
              {
                key: "3_7",
                label: 'My Sent IOU Back Requests',
                icon: "pi pi-sign-out",
                command:async ()=>{
                  this.menuClose("/my-sent-iou-back-requests");
                }
              },
              {
                key: "3_8",
                label: 'My Received IOU Back Requests',
                icon: "pi pi-sign-in",
                command:async ()=>{
                  this.menuClose("/my-received-iou-back-requests");
                }
              },
              {
                key: "3_9",
                label: 'Bill Discount Application',
                icon: "pi pi-percentage",
                command:async ()=>{
                  this.menuClose("/bill-discount-application/Pending");
                }
              },
            ]
          },
          {
            key: "4",
            label: 'Requisitions',
            icon: "pi pi-file",
            items: [
              {
                key: "4_0",
                label: 'Drafts',
                icon: "pi pi-pencil",
                command:async ()=>{
                  this.menuClose("/drafts");
                }
              },
              {
                key: "4_1",
                label: 'My Installation Requisitions',
                icon: "pi pi-cog",
                command:async ()=>{
                  this.menuClose("/my-installation-requisitions");
                }
              },
              {
                key: "4_2",
                label: 'My Installation Assignments',
                icon: "pi pi-wrench",
                command:async ()=>{
                  this.menuClose("/my-installation-assignments");
                }
              },
              {
                key: "4_3",
                label: 'Create Service Requisition',
                icon: "pi pi-file-edit",
                command:async ()=>{
                  this.menuClose("/create-service-requisition");
                }
              },
              {
                key: "4_4",
                label: 'Service Requisitions',
                icon: "pi pi-list",
                command:async ()=>{
                  this.menuClose("/service-requisitions");
                }
              },
              {
                key: "4_5",
                label: 'My Service Assignments',
                icon: "pi pi-briefcase",
                command:async ()=>{
                  this.menuClose("/my-service-assignments");
                }
              },
            ]
          },
          {
            key: "5",
            label: 'Ships',
            icon: "pi pi-compass",
            items: [
              {
                key: "5_0",
                label: 'Assign GPS Device To Ship',
                icon: "pi pi-tag",
                command:async ()=>{
                  this.menuClose("/assign-gps-device");
                }
              },
              {
                key: "5_1",
                label: 'Pick GPS Device from Ship',
                icon: "pi pi-arrow-circle-down",
                command:async ()=>{
                  this.menuClose("/pick-gps-device-from-ship");
                }
              },
              {
                key: "5_2",
                label: 'Ship Last Position',
                icon: "pi pi-map",
                command:async ()=>{
                  this.menuClose("/ship-last-position");
                }
              },
              {
                key: "5_3",
                label: 'Ship Manpower Registration',
                icon: "pi pi-users",
                command:async ()=>{
                  this.menuClose("/ship-manpower");
                }
              },
              {
                key: "5_4",
                label: 'Ship Picture',
                icon: "pi pi-images",
                command:async ()=>{
                  this.menuClose("/ship-picture");
                }
              },
              {
                key: "5_5",
                label: 'Edit Ship',
                icon: "pi pi-pencil",
                command:async ()=>{
                  this.menuClose("/edit-ship");
                }
              },
              {
                key: "5_6",
                label: 'My Ship Pricing Log',
                icon: "pi pi-money-bill",
                command:async ()=>{
                  this.menuClose("/my-ship-pricing-log");
                }
              },
            ]
          },
          {
            key: "6",
            label: 'GPS Device',
            icon: "pi pi-mobile",
            items: [
              {
                key: "6_0",
                label: 'New GPS Device',
                icon: "pi pi-plus-circle",
                command:async ()=>{
                  this.menuClose("/new-gps-device");
                }
              },
              {
                key: "6_1",
                label: 'My GPS Device',
                icon: "pi pi-tablet",
                command:async ()=>{
                  this.menuClose("/my-gps-device");
                }
              },
              {
                key: "6_2",
                label: 'My Sent Transfer Request',
                icon: "pi pi-arrow-right",
                command:async ()=>{
                  this.menuClose("/my-sent-gps-device-transfer-request");
                }
              },
              {
                key: "6_3",
                label: 'My Received Transfer Request',
                icon: "pi pi-arrow-left",
                command:async ()=>{
                  this.menuClose("/my-received-gps-device-transfer-request");
                }
              },
            ]
          },
          {
            key: "7",
            label: 'Jahaji Service',
            icon: "pi pi-server",
            items: [
              {
                key: "7_0",
                label: 'Create Boat',
                icon: "pi pi-compass",
                command:async ()=>{
                  this.menuClose("/create-boat");
                }
              },
              {
                key: "7_1",
                label: 'Create Ghat',
                icon: "pi pi-map-marker",
                command:async ()=>{
                  this.menuClose("/create-ghat");
                }
              },
            ]
          },
          {
            key: "8",
            label: 'Help Center',
            icon: "pi pi-question-circle",
            command:async ()=>{
              this.menuClose("/help");
            }
          },
        ]
    }
  },
  watch: {
    // Re-check on every navigation which guide (if any) belongs to the new screen.
    $route() {
      this.helpOpen = false;
      this.updateHelpButton();
      refreshDocsIndex().then(() => this.updateHelpButton());
    },
  },
  methods:{
    updateHelpButton(){
      const matched = this.$route.matched;
      const pattern = matched.length ? matched[matched.length - 1].path : undefined;
      const guide = this.$route.path === '/login' ? null : docForRoute(pattern);
      this.helpSlug = guide ? guide.slug : null;
      this.helpAnchor = guide ? guide.anchor : null;
      this.helpUpdated = !!(guide && guide.doc && isUpdatedSinceSeen(guide.slug, guide.doc.version));
    },
    menuOpened(){
      this.name=window.localStorage.name;
      this.email=window.localStorage.email;
      this.avatarImg = window.localStorage.avatarImg != null ? window.localStorage.avatarImg : null;

      const hrMenu = this.items.find((item: any) => item.label === 'HR Management');
      if (hrMenu && hrMenu.items) {
        // Only inject the Team Daily Attendance report into the menu if the user is an admin
        const hasTeamDaily = hrMenu.items.some((item: any) => item.label === 'Team Daily Attendance');
        const userType = window.localStorage.getItem('user_type');
        if ((userType === 'admin' || userType === 'entry') && !hasTeamDaily) {
          hrMenu.items.push({
            key: "1_6",
            label: 'Team Daily Attendance',
            icon: "pi pi-users",
            command: async ()=>{
              this.menuClose("/hr/team-daily");
            }
          });
        }

        // Only Admins can recall an employee from an already-approved leave.
        const hasRecallLeave = hrMenu.items.some((item: any) => item.label === 'Recall Leave');
        if (userType === 'admin' && !hasRecallLeave) {
          hrMenu.items.push({
            key: "1_8",
            label: 'Recall Leave',
            icon: "pi pi-replay",
            command: async ()=>{
              this.menuClose("/hr/recall-leave");
            }
          });
        }
      }
    },
    async menuClose(to: string){
      this.$router.push(to);
      await menuController.toggle();
    },
    async logout(){
      await menuController.close('main-content');
      // window.localStorage.clear();
      await this.$http.post('logout',{username:window.localStorage.getItem('username'),password:window.localStorage.getItem('password')});
        window.localStorage.removeItem('name');
        window.localStorage.removeItem('password');
        window.localStorage.removeItem('email');
        window.localStorage.removeItem('username');
      this.$router.push('/login');
    },
    async openNotificationToast(notification: PushNotificationSchema) {
      const toast = await toastController
        .create({
          header: notification.title,
          message: notification.body,
          position: 'top',
          buttons: [
            {
              side: 'end',
              icon: 'notification',
              text: 'View',
              handler: () => {
                this.openPush(notification.data);
              }
            }
          ]
        })
      await toast.present();
    },
    // Opens the screen a notification is about (e.g. /hr/leave-approvals?id=42).
    openPush(data: any) {
      const route = pushRoute(data);
      if (!route) return;
      if (window.localStorage.username == null || window.localStorage.password == null) {
        // Signed out: Login.vue opens it right after sign-in.
        rememberPushRoute(route);
        this.$router.push('/login');
        return;
      }
      this.$router.push(route);
    },
  },
 async mounted(){
    // Load the list of screen guides (cached on the phone; refreshed at most every 10 minutes).
    this.updateHelpButton();
    refreshDocsIndex(true).then(() => this.updateHelpButton());
    if(isPlatform('android') &&  !( window.localStorage.username==null || window.localStorage.password==null)){
                
         await this.$http.post('shouldLogout',{username:window.localStorage.getItem('username'), password:window.localStorage.getItem('password'), 'fcm_token':window.localStorage.getItem('fcm_token')}).then(response=>{
            if(response.data.status){
              window.localStorage.removeItem('name');
              window.localStorage.removeItem('password');
              window.localStorage.removeItem('email');
              window.localStorage.removeItem('username');
              this.$router.push('/login');
            }
          });
        }
    this.name=window.localStorage.name;
    this.email=window.localStorage.email;
    
    if (Capacitor.isNativePlatform() && isPlatform('android')) {
      // Listeners before register(), so neither the token nor a notification tapped while the
      // app was closed can be missed.
      PushNotifications.addListener('registration', (token: Token) => {
        window.localStorage.setItem('fcm_token', token.value);
        if( !( window.localStorage.username==null || window.localStorage.password==null)){
          // Saves this phone's token on the signed-in user, so their notifications reach this phone.
          this.$http.post('login',{username:window.localStorage.getItem('username'), password:window.localStorage.getItem('password'), 'fcm_token':token.value}, { skipLoading: true });
        }
      });

      PushNotifications.addListener('registrationError', (error: any) => {
        console.error('Push notification registration failed', error);
      });

      PushNotifications.addListener(
        'pushNotificationReceived',
        (notification: PushNotificationSchema) => {
          // Lets an open list (e.g. Leave Approvals) reload with the new request.
          window.dispatchEvent(new CustomEvent(PUSH_EVENT, { detail: notification.data }));
          this.openNotificationToast(notification);
        },
      );

      PushNotifications.addListener(
        'pushNotificationActionPerformed',
        (notification: ActionPerformed) => {
          this.openPush(notification.notification.data);
        },
      );

      // Heads-up channel the server sends requests and approvals to. Creating the app's first
      // channel is also what makes Android 13+ ask "Allow notifications?" for this build.
      PushNotifications.createChannel({
        id: PUSH_CHANNEL,
        name: 'Requests & approvals',
        description: 'Leave, attendance and other requests waiting for you, and decisions on yours',
        importance: 4,
        visibility: 1,
        vibration: true,
      }).catch(() => undefined);

      PushNotifications.requestPermissions().then(result => {
        if (result.receive === 'granted') {
          PushNotifications.register();
        }
      });
    }else{
      window.localStorage.setItem('fcm_token', "test");
    }
  },
  setup() {
    const selectedIndex = ref(0);
    const appPages = [
      {
        title: 'Home',
        url: '/home',
        iosIcon: homeOutline,
        mdIcon: home
      },
      {
        title: 'All Sales',
        url: '/all-sales',
        iosIcon: rocketOutline,
        mdIcon: rocket
      },
      {
        title: 'Request IOU',
        url: '/request-iou',
        iosIcon: rocketOutline,
        mdIcon: rocket
      },
      {
        title: 'My Received IOU Requests',
        url: '/my-received-iou-requests',
        iosIcon: rocketOutline,
        mdIcon: rocket
      },
      {
        title: 'My Sent IOU Requests',
        url: '/my-sent-iou-requests',
        iosIcon: rocketOutline,
        mdIcon: rocket
      },
      {
        title: 'Bill Submit',
        url: '/bill-submit',
        iosIcon: rocketOutline,
        mdIcon: rocket
      },
      {
        title: 'My Bills',
        url: '/my-bills',
        iosIcon: rocketOutline,
        mdIcon: rocket
      },
      {
        title: 'Received Bill Requests',
        url: '/received-bill-requests',
        iosIcon: rocketOutline,
        mdIcon: rocket
      },
      {
        title: 'Create Sale',
        url: '/create-sale',
        iosIcon: rocketOutline,
        mdIcon: rocket
      },
      // {
      //   title: 'Client Register',
      //   url: '/client-register',
      //   iosIcon: personAddOutline,
      //   mdIcon: personAdd
      // },
      // {
      //   title: 'Existing Client',
      //   url: '/existing-client',
      //   iosIcon: personOutline,
      //   mdIcon: person
      // },
      {
        title: 'Drafts',
        url: '/drafts',
        iosIcon: documentOutline,
        mdIcon: document
      },
      {
        title: 'Ship Manpower Registration',
        url: '/ship-manpower',
        iosIcon: walkOutline,
        mdIcon: walk
      },
      {
        title: 'Edit Ship',
        url: '/edit-ship',
        iosIcon: boatOutline,
        mdIcon: boat
      },
      {
        title: 'My Ship Pricing Log',
        url: '/my-ship-pricing-log',
        iosIcon: boatOutline,
        mdIcon: boat
      },
      {
        title: 'Ship Picture',
        url: '/ship-picture',
        iosIcon: imageOutline,
        mdIcon: image
      },
      {
        title: 'My Sales',
        url: '/my-sales',
        iosIcon: rocketOutline,
        mdIcon: rocket
      },
      {
        title: 'My Installation Requisitions',
        url: '/my-installation-requisitions',
        iosIcon: rocketOutline,
        mdIcon: rocket
      },
      {
        title: 'My Installation Assignments',
        url: '/my-installation-assignments',
        iosIcon: rocketOutline,
        mdIcon: rocket
      },
      {
        title: 'Create Service Requisition',
        url: '/create-service-requisition',
        iosIcon: cogOutline,
        mdIcon: cog
      },
      {
        title: 'Service Requisitions',
        url: '/service-requisitions',
        iosIcon: cogOutline,
        mdIcon: cog
      },
      {
        title: 'My Service Assignments',
        url: '/my-service-assignments',
        iosIcon: cogOutline,
        mdIcon: cog
      },
      {
        title: 'New GPS Device',
        url: '/new-gps-device',
        iosIcon: locateOutline,
        mdIcon: locate
      },
      {
        title: 'My GPS Device',
        url: '/my-gps-device',
        iosIcon: locateOutline,
        mdIcon: locate
      },
      {
        title: 'My Sent Transfer Request',
        url: '/my-sent-gps-device-transfer-request',
        iosIcon: locateOutline,
        mdIcon: locate
      },
      {
        title: 'My Received Transfer Request',
        url: '/my-received-gps-device-transfer-request',
        iosIcon: locateOutline,
        mdIcon: locate
      },
      {
        title: 'Assign GPS Device To Ship',
        url: '/assign-gps-device',
        iosIcon: locateOutline,
        mdIcon: locate
      },
      {
        title: 'Pick GPS Device from Ship',
        url: '/pick-gps-device-from-ship',
        iosIcon: locateOutline,
        mdIcon: locate
      },
      {
        title: 'Ship Last Position',
        url: '/ship-last-position',
        iosIcon: navigateOutline,
        mdIcon: navigate
      }
    ];
    const labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];
    
    const path = window.location.pathname;
    if (path !== undefined) {
      selectedIndex.value = appPages.findIndex(page => page.url === path.toLowerCase());
    }
    
    const route = useRoute();
    
    return { 
      selectedIndex,
      appPages, 
      labels,
      home,
      homeOutline,
      personAdd,
      personAddOutline,
      person,
      personOutline,
      walk,
      walkOutline,
      image,
      imageOutline,
      rocket,
      rocketOutline,
      cog,
      cogOutline,
      locate,
      locateOutline,
      navigate,
      navigateOutline,
      logOut,
      logOutOutline,
      documentOutline,
      document,
      boat,
      boatOutline,
      isSelected: (url: string) => url === route.path ? 'selected' : ''
    }
  }
});
